import { Col, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import JobListings from '../Jobs/JobListings'
import PriceProposals from './PriceProposals'

const ServiceProviderQuotation = () => {
    const [selectedOption, setSelectedOption] = useState(1)
    
    const user = useSelector(state => state?.auth?.loggedInUser)
    const spOptions = [
        {
            id:1,
            label:'Job Listing',
            component: <JobListings/>
        },
        {
            id:2,
            label:'Price Proposals',
            component: <PriceProposals/>
        },
    ]

    useEffect(() => {
      setSelectedOption(spOptions[0])
    }, [])
    

    return (
        <Row>
            <Col md={24} sm={24} xs={24} className="md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6">
                <div className='sm:mb-2 mb-6 pr-2 flex' id='booking-list'>
                    { user && user?.type == 'Service Provider' && spOptions.map(option => (
                        <span 
                            key={option?.id} 
                            className={`${selectedOption.id == option?.id ? 'bg-primary text-white' : 'bg-[#FEEDBF] text-black'} 
                            text-xs p-3 font-semibold rounded-sm cursor-pointer`}
                            onClick={()=>setSelectedOption(option)}
                        >
                            {option?.label}
                        </span>
                    )) }
                </div>
                { selectedOption && selectedOption.component }
            </Col>
        </Row>

    )
}

export default ServiceProviderQuotation